import type { JSX } from 'react';
import { Alert } from '@ksyos/design-system';

export function BariatricsExternalReferralAlert(): JSX.Element {
    return (
        <Alert appearance="info">
            Vergeet niet om, als het nodig is, de verwijsbrief naar de juiste instantie te mailen.
        </Alert>
    );
}
